import { Box } from '@mui/material';
import { isProduction } from '../../config';

/**
 * Badge indicator showing when using test database
 * Only visible in development/test environments
 */
export function TestDatabaseIndicator() {
  if (isProduction) return null;

  return (
    <Box
      color={theme => theme.palette.error.main}
      fontSize={8}
      sx={{
        position: 'fixed',
        left: 10,
        bottom: 10,
        zIndex: 10000
      }}
    >
      Base de données de test
    </Box>
  );
}
